<d-header
  [homeUrl]="'/'"
  [showMenuButton]="true"
  [settingsCustomMenuItems]="hostAppCustomMenuItems()"
  [productMenuItems]="productMenuItems()"
  (menuBtnClicked)="handleMenuBtnClicked()"
  (logoutClicked)="handleLogout()"
  (supportClicked)="onSupportClicked()"
  (helpClicked)="onHelpClicked()"
  (userSettingsClicked)="onUserSettingsClicked()"
  (systemInfoClicked)="onSystemInfoClicked()" />

<d-navigation-menu
  [(opened)]="navigationMenuOpen"
  [navigationItems]="navigationMenuItems()"
  [(activeLeafItem)]="activeNavItem"
  *transloco="let t; prefix: 'licensing'">
  <div class="licensing-layout">
    <router-outlet />
  </div>
</d-navigation-menu>
